import { FC, useContext } from "react"
import { NavLink, useHistory } from "react-router-dom";
import { ZipProjectContext } from "./ZipProjectContext";
import { ZipProjectModuleRoutesEnum } from "./interfaces";

export const ZipProjectModuleNav: FC = () => {
  const projectContext = useContext(ZipProjectContext);
  const history = useHistory();
  const { state } = projectContext;

  return (
    <div className="tabs-style-2">
      <div className="d-flex justify-content-between align-items-center">
        <ul className="nav nav-tabs" role="menu">
          {!!state.project && !state.loading ? (
            <>
              <li className="nav-item" role="none">
                <NavLink
                  className="nav-link"
                  activeClassName="active"
                  role="menuitem"
                  to={`/projects/${state.project.projectId}/${ZipProjectModuleRoutesEnum.Adequacy}${history.location.search}`}
                >
                  Adequacy
                </NavLink>
              </li>
              {state.shouldShowSummariesTab && <li className="nav-item" role="none"><NavLink className="nav-link" activeClassName="active" to={`/projects/${state.project.projectId}/${ZipProjectModuleRoutesEnum.Summary}`} role="menuitem">Summaries</NavLink></li>}
            </>
          ) : (
            <>
              <li className="nav-item" role="none"><span className="nav-link">Adequacy</span></li>
              {state.shouldShowSummariesTab && <li className="nav-item" role="none"><span className="nav-link">Summaries</span></li>}
            </>
          )}
        </ul>
      </div>
    </div>
  )
}